import { render, staticRenderFns } from "./shipping_page.vue?vue&type=template&id=580c4c1b&"
import script from "./shipping_page.vue?vue&type=script&lang=js&"
export * from "./shipping_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports